import { render, staticRenderFns } from "./VideoJs.vue?vue&type=template&id=ed519606"
import script from "./VideoJs.vue?vue&type=script&lang=js"
export * from "./VideoJs.vue?vue&type=script&lang=js"
import style0 from "./VideoJs.vue?vue&type=style&index=0&id=ed519606&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.3_webpack@5.107.2__lodash@4.18.1_react-dom@16.2.0_rea_78eced9430f46a1a0ce5e8103c760d82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports